import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth.js";

/**
 * Route guard.
 *
 * This is the whole of what dropping Next.js cost us (D-17): middleware.ts
 * became a component. About a dozen lines.
 *
 * The `loading` branch matters -- without it the app flashes the login page
 * for a moment on every reload while /api/me is still in flight, which reads
 * as being logged out.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === "loading") {
    return (
      <div className="centered">
        <p className="muted">Checking your session…</p>
      </div>
    );
  }

  if (state.status === "anonymous") {
    // Remember where they were headed so login can send them back there
    // instead of dumping everyone on the same page.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
